export default __webpack_public_path__ + "static/media/print.8aef4711.svg";